import { Button } from "@/components/ui/button";
import type { DemoYear } from "../types/agricultural-lulc";

interface YearToggleProps {
  year: DemoYear;
  onChange: (year: DemoYear) => void;
  excludeChange?: boolean;
}

export function YearToggle({ year, onChange, excludeChange }: YearToggleProps) {
  return (
    <div className="inline-flex items-center rounded-lg border border-border bg-muted/50 p-0.5">
      <Button
        variant={year === 2024 ? "default" : "ghost"}
        size="sm"
        className="h-7 px-3 text-xs"
        onClick={() => onChange(2024)}
      >
        2024
      </Button>
      <Button
        variant={year === 2025 ? "default" : "ghost"}
        size="sm"
        className="h-7 px-3 text-xs"
        onClick={() => onChange(2025)}
      >
        2025
      </Button>
      {!excludeChange && (
        <Button
          variant={year === "change" ? "default" : "ghost"}
          size="sm"
          className="h-7 px-3 text-xs"
          onClick={() => onChange("change")}
        >
          Change
        </Button>
      )}
    </div>
  );
}
